import { API_ENDPOINTS } from '../config/api';

const DEFAULT_BEARER_TOKEN = '';

// Hàm xử lý chung cho response
const handleApiResponse = async (response) => {
  const data = await response.json();
  
  if (data.error_code === 1000) {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    window.location.href = '/';
    throw new Error('Phiên đăng nhập hết hạn');
  }

  if (!response.ok) {
    throw new Error(data.message || 'Có lỗi xảy ra');
  }

  return data;
};

// Lưu token notification
export const saveNotificationToken = async (token) => {
  try {
    const authToken = localStorage.getItem('token');
    
    const response = await fetch(API_ENDPOINTS.SAVE_NOTIFICATION_TOKEN, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken || DEFAULT_BEARER_TOKEN}`
      },
      body: JSON.stringify({
        token,
        device_info: {
          userAgent: navigator.userAgent,
          platform: navigator.platform
        }
      })
    });

    return handleApiResponse(response);
  } catch (error) {
    console.error('Lỗi khi lưu notification token:', error);
    throw error;
  }
};

// Lấy thông báo
export const getNotifications = async ($perPage,$page) => {
  try {
    const authToken = localStorage.getItem('token');
    const response = await fetch(API_ENDPOINTS.GET_NOTIFICATIONS + "?per_page=" + $perPage + "&page=" + $page, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${authToken || DEFAULT_BEARER_TOKEN}` },
    });

    return handleApiResponse(response);
  } catch (error) {
    console.error('Lỗi khi lấy thông báo:', error);
    throw error;
  }
};

export const markAsRead = async ($notificationId) => {
  try {
    const authToken = localStorage.getItem('token');
    const response = await fetch(API_ENDPOINTS.READ_NOTIFICATION + "?notification_id=" + $notificationId, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${authToken || DEFAULT_BEARER_TOKEN}` },
    });

    return handleApiResponse(response);
  } catch (error) {
    console.error('Lỗi khi đánh dấu thông báo đã đọc:', error);
    throw error;
  }
}

export const readAllNotifications = async () => {
  try {
    const authToken = localStorage.getItem('token');
    const response = await fetch(API_ENDPOINTS.READ_ALL_NOTIFICATION, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${authToken || DEFAULT_BEARER_TOKEN}` },
    });

    return handleApiResponse(response);
  } catch (error) {
    console.error('Lỗi khi đánh dấu tất cả thông báo đã đọc:', error);
    throw error;
  }
}
